import { Label, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutOrderPlanningProfileLookup } from "./autogen/AutogenLayoutOrderPlanningProfileLookup";

export class OrderPlanningProfileLookup extends AutogenLayoutOrderPlanningProfileLookup {

    tableLookupOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const label = tableRow.findComponentById("labelTitle") as Label;
        label.text = tableRow.data.get("title", tableRow.data.get("id"));
    }
}
